/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
} from "../../runtime/index.jsx";
export function Componente_lk_108_107(e) {
  let t = (0, ReactCompiler.c)(2),
    { children: n } = e,
    r;
  return (
    t[0] === n
      ? (r = t[1])
      : ((r = (
          <p
            className={`rounded-xl border border-dashed border-(--border) px-3 py-4 text-center text-sm text-(--text)`}
            children={n}
          />
        )),
        (t[0] = n),
        (t[1] = r)),
    r
  );
}
